import * as types from "./types";
import INITIAL_STATE from "./init";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_UPDATE_FLAG:
      return { ...state, shouldUpdate: action.payload };
    case types.SET_DEMOGRAPHICS:
      return { ...state, demographics: action.payload };
    case types.TRIGGER_DEEP_UPDATE:
      return { ...state, shouldDeepUpdate: true };
    case types.DEEP_UPDATE_COMPLETE:
      return { ...state, shouldDeepUpdate: false };
    case types.SET_DEVICE_NAME:
      return { ...state, device: action.payload };
    default:
      return state;
  }
};
